import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { formsV2 as Forms } from '@breezeway/brzw-components';
import { CLASS_NAME, MOUSE_DOWN_EVENT_NAME } from './constants';

import './saved_views_component.scss';

export class SavedViewsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpened: false,
    };

    this.containerRef = React.createRef();

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.onCreateOption = this.onCreateOption.bind(this);
    this.onSelectedOption = this.onSelectedOption.bind(this);
    this.onSubSelectOption = this.onSubSelectOption.bind(this);
  }

  onCreateOption(value) {
    _.invoke(this.props, 'onCreatedOption', value);
    this.toggleMenu()
  }

  onSelectedOption(index, value) {
    _.invoke(this.props, 'onSelectOption', index, value);
    this.toggleMenu();
  }

  onSubSelectOption(value, object) {
    _.invoke(this.props, 'onSubSelectOption', value, object);
    this.toggleMenu();
  }

  toggleMenu() {
    this.setState(prevState => ({
      dropdownOpened: !prevState.dropdownOpened,
    }), () => {
      this.registerListeners(this.state.dropdownOpened);
    });
  }

  handleClickOutside(evt) {
    const { current } = this.containerRef;
    const { target } = evt;
    if (current && !current.contains(target)) {
      this.toggleMenu();
    }
  }

  bindOuterClickListener() {
    document.addEventListener(MOUSE_DOWN_EVENT_NAME, this.handleClickOutside);
  }

  unbindOuterClickListener() {
    document.removeEventListener(MOUSE_DOWN_EVENT_NAME, this.handleClickOutside);
  }

  registerListeners(status) {
    if (status) {
      this.bindOuterClickListener();
    } else {
      this.unbindOuterClickListener();
    }
  }

  render() {
    const { dropdownOpened } = this.state;
    const { className, options, selectedOption } = this.props;
    const selectedLabel = _.get(selectedOption, 'label', '');
    const selectedIcon = _.get(selectedOption, 'icon');
    const selectedValue = _.get(selectedOption, 'value');

    return (
      <div className={classnames(CLASS_NAME, className)} ref={this.containerRef}>
        <div
          className={`${CLASS_NAME}__trigger-button`}
          role="presentation"
          onClick={this.toggleMenu}
        >
          <div className={classnames(`${CLASS_NAME}__before-icon`,`icon-${selectedIcon}`)} />
          <p className={`${CLASS_NAME}__trigger-button-text`}>{selectedLabel}</p>
          <div className={classnames(`${CLASS_NAME}__after-icon`, 'icon-down')} />
        </div>
        {dropdownOpened && (
          <div className={`${CLASS_NAME}__select-wrapper`}>
            <Forms.SelectOptions
              creatable
              creatableText='Add new view'
              className={`${CLASS_NAME}__dropdown`}
              dropdownItemClassName={`${CLASS_NAME}__dropdown-item`}
              onCreateOption={this.onCreateOption}
              options={options}
              onSelectOption={this.onSelectedOption}
              onSubSelectOption={this.onSubSelectOption}
              selected={selectedValue}
            />
          </div>
        )}
      </div>
    );
  }
}

SavedViewsComponent.propTypes = {
  className: PropTypes.string,
  onCreatedOption: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
        }),
      ),
    }),
  ),
  selectedOption: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.string,
  }),
  onSelectOption: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  onSubSelectOption: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
};

SavedViewsComponent.defaultProps = {
  className: ''
};

export default SavedViewsComponent;
